import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "connector"]

  connect() {
    this.hoverTimeout = null
  }

  show(event) {
    // Clear any existing timeout
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout)
    }
    
    if (this.hasEnoughSpaceForSidebar()) {
      this.showGlobalPopover()
    }
  }

  hide(event) {
    // Verzögerung beim Verlassen, falls Benutzer zur Sidebar navigiert
    this.hoverTimeout = setTimeout(() => {
      this.hideGlobalPopover()
    }, 300) // 300ms Verzögerung
  }

  // Prüft ob genug Platz für die Sidebar ist
  hasEnoughSpaceForSidebar() {
    const triggerRect = this.element.getBoundingClientRect()
    const viewportWidth = window.innerWidth
    const sidebarWidth = 384 // w-96 = 384px
    
    // Prüfe ob genug Platz rechts für die Sidebar ist
    const spaceRight = viewportWidth - triggerRect.right
    return spaceRight >= sidebarWidth + 20 // 20px Puffer
  }

  // Zeigt den globalen Popover
  showGlobalPopover() {
    const globalPopover = document.querySelector('[data-controller*="global-popover"]')
    
    if (globalPopover) {
      const content = this.contentTarget.innerHTML
      globalPopover.dispatchEvent(new CustomEvent('global-popover:show', { 
        detail: { content: content } 
      }))
    }
  }

  // Versteckt den globalen Popover
  hideGlobalPopover() {
    const globalPopover = document.querySelector('[data-controller*="global-popover"]')
    
    if (globalPopover) {
      globalPopover.dispatchEvent(new CustomEvent('global-popover:hide'))
    }
  }


  showLoadingState() {
    // Für zukünftige Erweiterungen - z.B. beim Neuberechnen des Scores
  }

  // Bereinigt beim Entfernen des Controllers
  disconnect() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout)
    }
  }
}
